import { HttpContextToken } from "@angular/common/http";
import { environment } from "../../environments/environment";
export const baseURL = environment.authApiUrl + "/";
export const authUrl = environment.authApiUrl;

export const envName = environment.envName;

export const IS_LOCAL_TO_SERVER = environment.isLocalToServer;
export const IS_NGINX = (environment as any).isNginx === true;

export const VERSION = "v1";

export enum ApiVersion {
  V1 = 'v1',
  V2 = 'v2',
}

export const EDC_PORT = 4201;
export const ETMF_PORT = 4202;
export const TSM_PORT = 4203;
export const CTMS_PORT = 4205;
export const IWRS_PORT = 4206;

export const LOCAL_PROFILE = 'local';
export const DEV_PROFILE = 'dev';

export const ETMF_PLATFORM = 'eTMF';
export const TSM_PLATFORM = 'TSM';
export const EDC_PLATFORM = 'EDC';
export const CENTRAL_PLATFORM = 'CENTRAL';
export const CTMS_PLATFORM = 'CTMS';
export const IWRS_PLATFORM = 'IWRS'

export const STUDY_AND_ROLE_ROUTE = 'StudyAndRole';


export const CLINICAL_SUITE = 'Clinical Suite';
export const copyRight = `© 2026 ${CLINICAL_SUITE}. All rights reserved.`;

export const STUDY = 'study';
export const ROLE = 'role';
export const ENTITY ='entity';
export const WINDOW ='window';
export const ACTION ='action';
export const REPORT ='report';
export const MODULE ='module';
export const ACCOUNT ='account';
export const PERMISSION ='Permission';
export const MASTER ='Master';
export const THERAPEUTIC ='Therapeutic';
export const INDICATION ='Indication';
export const PHASE ='Phase';

// Logo and Branding Constants
export const NXTRIAL_IDENTIFIER = 'nxtrial';
export const MERILLIFE_IDENTIFIER = 'merillife';
export const PLATFORM = 'platform';

export const USER_NAME_PATTERN = /^[a-zA-Z0-9._]+$/;
export const NO_SPACE_PATTERN = /^\S*$/;

export const BAD_CREDENTIALS = "Bad credentials";
export const USER_NOT_FOUND = 'User not found';
export const UNAUTHORIZED = "Unauthorized";
export const OBJECT = 'object';

export const MAX_SEARCH_INPUT_LENGTH = 30;

const PREFIX:string = envName + '_';
/** Last activity time, shared by Auth and EDC tabs (same origin); logout sets it to LOGGED_OUT_VALUE. */
export const LAST_ACTIVITY_KEY = 'CS_LAST_ACTIVITY';
/** Value of LAST_ACTIVITY_KEY after a logout; other tabs seeing it follow the logout. */
export const LOGGED_OUT_VALUE = 'LOGGED_OUT';

export const COOKIE_KEYS = {
  STUDY_ID: PREFIX + 'studyId',
  ROLE: PREFIX + 'role',
  USER_ID: PREFIX + 'userId',
  USER_NAME: PREFIX + 'userName',
  STUDY_NAME: PREFIX + 'studyName'
} as const;

export const LOGIN_TEXT = 'Login';

export const JSESSIONID:string = 'JSESSIONID';
export const MOBILE_PLATFORM:string = 'MobilePlatform';

// Logo and Branding Constants
export const NXTRIAL_SPINNER_CLASS = 'nxtrial-spinner';
export const MERIL_SPINNER_CLASS = 'meril-spinner';

export const MODAL_CENTERED = { centered: true };
export const MODAL_SIZE_LG = { size: 'lg' as 'lg' };
export const MODAL_SIZE_MD = { size: 'md' as 'md' };
export const MODAL_SIZE_XL = { size: 'xl' as 'xl' };
export const MODAL_SIZE_SM = { size: 'sm' as 'sm' };
export const MODAL_BACKDROP_STATIC = { backdrop: "static" as "static" };


export const LOGOUT_CONFIRMATION = 'Are you sure you want to logout?';
export const RESET_PASSWORD = 'Reset Password';
export const RESET_PASSWORD_CONFIRMATION = 'Reset Password Confirmation';
export const CONFIRM_LOGOUT = "Logout Confirmation";
export const LOGOUT = "Logout";
export const CANCEL = "Cancel";
export const EMAIL_PATTERN = "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$";
export const URL_PATTERN =
  "^(?:(?:https?:\\/\\/)?(?:www\\.)?)[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)+(?:[/?#][^\\s]*)?$";
export const USER_MANUAL_NAME = "userManual"

export const ACTION_COLUMN: string = 'Action';
export const STRING = 'string';
export const DEFAULT_PAGE : number = 1;
export const ITEMS_PER_PAGE : number = 10;
export const DEFAULT_SERIAL_NUMBER : number = 1;
export const DEFAULT_PAGE_NO: number = 0;
export const DEFAULT_PAGE_SIZE: number = 10;

export const AUTH_TOKEN_API = "/auth/token";
export const AUTH_LOGIN_API = "/auth/login";

export const REFRESH_TOKEN_INVALID_MSG = 'Refresh token is invalid or expired (401)';
export const UNAUTHORIZED_OPERATION_MSG = 'You don’t have permission to perform this action';

export const SR_NO = "SrNo";

export enum ApiStatusCode {
  SUCCESS = 0,
  WARNING = 60,
  UNAUTHORIZED = 401,
  BAD_REQUEST = 400,
  NOT_FOUND = 404,
  CONFLICT = 409,
  INTERNAL_SERVER_ERROR = 500,
}

export enum AccountTypeCode {
  SITE = 'ST',
}

// Export types for file download
export const EXPORT_TYPES = [
  { name: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', extension: '.xlsx' },
  { name: 'application/pdf', extension: '.pdf' }
];

// Randomization types for study configuration
// export const RANDOMIZATION_TYPE = [
//   { id: 1, name: "Blinded" },
//   { id: 2, name: "Unblinded" }
// ];

export const USER_STATUS = [
  { isActive: true, name: "Enable" },
  { isActive: false, name: "Disable" }
];


export const EXTERNAL_USER_STATUS =[
  {isExternalUser : true, name: "Yes"},
  {isExternalUser : false, name:"No"}
] 

export const LOGIN_USER_STATUS =[
  {isLoginUser : true, name: "Yes"},
  {isLoginUser : false, name:"No"}
] 

// Resizable table constants
export const RESIZABLE_TABLE_MIN_COLUMN_WIDTH = 50;
export const RESIZABLE_TABLE_MAX_COLUMN_WIDTH = 400;
export const RESIZABLE_TABLE_ALL_COLUMNS = 'all';

export const TEXT_TRIM_COUNT_100 = 100

export const HEADER_PLATFORM = 'platform';
export const HEADER_ROLE_ID = 'roleId';
export const HEADER_STUDY_ID = 'studyId';
export const HEADER_AUDIT_REASON = 'X-Audit-Reason';

export const SKIP_PLATFORM_HEADER = new HttpContextToken<boolean>(() => false);

export enum PlatformEnum{
 EDC ='EDC',
 eTMF ='eTMF',
 CENTRAL='CENTRAL',
 CTMS='CTMS',
 IWRS='IWRS',
}

export const NON_INTEGER_KEYS: readonly string[] = ['.', 'e', 'E', '+', '-'];
